module.exports = __webpack_public_path__ + "img/connection-left-2.282a1de6.png";